export default __webpack_public_path__ + "static/nilson-efc4d796fb98a287033bd18ae124d0f1.png";